export default{
    namespaced: true,
    state() {
        return {
            locale : "it"
        }
    },
    getters: {
        locale: state => {
            return state.locale
        },
    },
    mutations: {
       locale: function(state , payload) {
            state.locale = payload
        },
    },
    actions: {
    }
};